import React from "react";
import { ProgressBar } from "react-bootstrap";

/**
 * PlanLimitBar — barra de uso vs límite efectivo.
 *
 * Props:
 *   used           {number}      — unidades consumidas
 *   plan_limit     {number|null} — límite del plan base (null = ilimitado)
 *   effective_limit{number|null} — límite real plan + bloques (null = ilimitado)
 *   label          {string}      — descripción legible de la dimensión
 *
 * Color: verde < 70%, amarillo 70–90%, rojo > 90%
 */
function PlanLimitBar({ used, plan_limit, effective_limit, label }) {
  const limit = effective_limit ?? plan_limit ?? null;
  const isUnlimited = limit === null;
  const pct = isUnlimited ? 0 : Math.min(100, Math.round((used / limit) * 100));
  const variant = pct > 90 ? "danger" : pct > 70 ? "warning" : "success";
  const hasExpansion = effective_limit != null && effective_limit !== plan_limit && plan_limit != null;

  return (
    <div className="mb-3">
      {/* label encima en móvil, al lado en desktop */}
      <div className="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center mb-1 gap-1">
        <span className="small fw-medium">{label}</span>
        <span className="small text-muted">
          {used} / {isUnlimited ? "∞" : limit}
          {hasExpansion && (
            <span className="ms-1 badge bg-info-subtle text-info-emphasis" style={{ fontSize: "0.7em" }}>
              +bloques
            </span>
          )}
        </span>
      </div>
      <ProgressBar
        now={isUnlimited ? 100 : pct}
        variant={isUnlimited ? "success" : variant}
        role="progressbar"
        aria-valuenow={used}
        aria-valuemin={0}
        aria-valuemax={isUnlimited ? used : limit}
        aria-label={`${label}: ${used} de ${isUnlimited ? "ilimitado" : limit}`}
        style={{ height: "8px" }}
      />
    </div>
  );
}

export { PlanLimitBar };
